/**
 * The river's course (lifted from lantern-water's `river-course.js` and
 * `world.js` `riverBankHeight`): the canal's narrow town reach, opening into
 * broader water beyond both ends; and the height of the banks outside the
 * walkable district. three.js axes (z is south). The curve's arithmetic stays
 * as lifted; the town reach's banks (3.8 and 10.5) are the scene's terrain.
 */
const smooth = (v: number, a: number, b: number): number => {
  const t = Math.max(0, Math.min(1, (v - a) / (b - a)));
  return t * t * (3 - 2 * t);
};

/** The west (or `east`) bank's x at z. */
export const riverCoast = (z: number, east = false): number => {
  const south = smooth(z, 16, 48);
  const north = smooth(-z, 34, 78);
  const bend = Math.sin(z * 0.12) * south * 2 + Math.sin((-z - 34) * 0.055) * north * 3;
  return east ? 10.5 + south * 29 + north * 17 + bend : 3.8 - south * 31 - north * 20 + bend;
};

/** The bank's height at (x, z): a muddy shore by the water, rising to rolling ground past the town's rails. */
export const riverBankHeight = (x: number, z: number, east = false): number => {
  const distance = Math.abs(x - riverCoast(z, east));
  const shore = -1.25 + smooth(distance, 0, 3) * 1.1;
  const outside = east ? Math.max(0, x - 22) : Math.max(0, -21 - x);
  const rise = smooth(outside, 0, 22);
  return shore + rise * (0.6 + Math.sin(x * 0.11 + z * 0.045) * 0.35 + Math.cos(z * 0.16) * 0.28);
};
